import Header from "../headers/light.js";
import { Outlet } from "react-router-dom";
import Footer from "components/footers/MiniCenteredFooter.js";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";

const Layout = () => {
  return (
    <AnimationRevealPage>
      <Header />
      <Outlet />
      <Footer />
    </AnimationRevealPage>
  );
};

export default Layout;
